const translations = {
    en: {
        events: {
            map_banner: {
                header: "EVENTS & ATTRACTIONS",
                title: "Always know what to do.",
                text: "Monuments, exhibitions, guided tours and much more: here you will find lots of ideas for your free time"
            }
        }
    },
    de: {
        events: {
            map_banner: {
                header: "EREIGNISSE UND ATTRAKTIONEN",
                title: "Damit immer wissen, was zu tun ist.",
                text: "Denkmäler, Ausstellungen, Führungen und vieles mehr: hier finden Sie viele Ideen für Ihre Freizeit"
            }
        }
    },
    es: {
        events: {
            map_banner: {
                header: "EVENTOS Y ATRACCIONES",
                title: "Siempre hay algo que ver en la ciudad.",
                text: " Monumentos, exhibitiones , excursiónes guiadas y mucho mas: aqui puede encontrar muchas ideas para ocupar su tiempo libre "
            }
        }
    },
    fr: {
        events: {
            map_banner: {
                header: "ÉVÉNEMENTS & ATTRACTIONS",
                title: "Il y a toujours quelque chose à voir dans la ville",
                text: "Monuments, expositions, visites guidées et bien plus encore: vous y trouverez de nombreuses idées pour votre temps libre"
            }
        }
    },
    it: {
        events: {
            map_banner: {
                header: "EVENTI E ATTRAZIONI",
                title: "C’è sempre qualcosa da vedere in città",
                text: "Monumenti, mostre, tour guidati e molto altro: qui trovi tanti spunti per il tuo tempo libero"   
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/events/MapBanner.js